import apiClient from '../../clienteFebosAPI';

const RESOURCE = '/aduanas/bitacoras';

export const getBinnacleList = ({
  id, page, items, filter
}) => {
  const params = apiClient.queryParams({ pagina: page, filas: items, filtros: filter });
  return apiClient.get(`${RESOURCE}/${id}?${params}`, {
    operacionId: 'aduanas.binnacle.list'
  });
};
